import React, {Component} from 'react'
import {Grid, Row, Col} from 'react-bootstrap'

import './Layout/PaymentResult.css'

class PaymentResultScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      status: props.location.query.status,
      message: props.location.query.message,
      type: props.location.query.type
    }
  }

  render () {
    const { status, message, type } = this.state
    return (
      <div id="payment-result-screen">
        <Grid>
          <Row>
            <Col lg={10} lgOffset={1} sm={10} smOffset={1}>
              <Row className={`title ${type}`}>
                <h2>نتیجه عملیات</h2>
              </Row>
              <Row className="wrapper">
                <div className={`payment-result ${status}`}>
                  {message}
                </div>
              </Row>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default PaymentResultScreen



// WEBPACK FOOTER //
// ./src/components/PaymentResult/PaymentResultScreen.js